import React from "react"

import {PerkRedemptionsReport} from "@irati/types"
import {H4} from "@irati/ui/src/Typography"

import SavingsTable from "./SavingsTable"

interface Props {
  data?: PerkRedemptionsReport[]
}

const UserSavingsReport = ({data = []}: Props) => {
  if (!data.length) return null
  return (
    <>
      <H4 marginBottom={2}>Your popular perks</H4>
      <SavingsTable data={data} showSavings />
    </>
  )
}

export default UserSavingsReport
